import { render, staticRenderFns } from "./InvoiceParameterText.vue?vue&type=template&id=1aa97c61&"
import script from "./InvoiceParameterText.vue?vue&type=script&lang=js&"
export * from "./InvoiceParameterText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports